import * as VerificationConstants from './constants';
import * as D from './deps';

export function isEligibleForAutoVerification(
  isDiscountVerificationInfoLoaded,
  discountVerificationStatus,
) {
  return !!(isDiscountVerificationInfoLoaded && !discountVerificationStatus);
}

export function isDiscountVerificationStatusVerified(discountVerificationStatus) {
  return (
    discountVerificationStatus === VerificationConstants.VerificationStatus.VERIFIED ||
    discountVerificationStatus === VerificationConstants.VerificationStatus.RE_VERIFIED
  );
}

export function getIsDiscountPaymentPageReady(
  isAvailableProductsLoaded,
  isSubscriptionInfoLoaded,
  isDiscountVerificationInfoLoaded,
  discountVerificationDocumentUploadUrl,
  hasSeenPlanDetails,
) {
  return (
    isAvailableProductsLoaded &&
    isSubscriptionInfoLoaded &&
    isDiscountVerificationInfoLoaded &&
    (!discountVerificationDocumentUploadUrl || !hasSeenPlanDetails)
  );
}

export function isStudentReverificationDenied4Year(discountVerificationStatus) {
  return discountVerificationStatus === VerificationConstants.VerificationStatus.DENIED_4_YEAR;
}

export function isInStudentReverificationPeriod(
  activeProductDiscountType,
  isDiscountVerificationInfoLoaded,
  discountVerificationStatus,
) {
  return (
    isDiscountVerificationInfoLoaded &&
    activeProductDiscountType === D.PaymentsConstants.discountTypes.STUDENT &&
    !discountVerificationStatus
  );
}
